const ENAnalysisPanel = {
	"Análise adicionada com sucesso": "Analysis successfully added",
	"Análise alterada com sucesso": "Analysis successfully changed",
	"Análise excluída com sucesso": "Analysis successfully deleted",
	"Adicionar {{label}}": "Add {{label}}",
	"Adicionar Item Swot": "Add Item Swot",
	"Adicione ao menos uma permissão": "Add at least one permission",
	"Alterar {{label}}": "Change {{label}}",
	"Alterar análise": "Change analysis",
	"Anexos {{label}}": "Attachments {{label}}",
	"Avaliação Gráfico": "Chart Evaluation",
	"Avaliação": "Evaluation",
	"Criar Item SWOT": "Create Item SWOT",
	"Comentários {{label}}": "Comments {{label}}",
	"Deseja realmente excluir a análise": "Do you really want to delete the analysis",
	"Deseja realmente excluir {{label}}": "Do you really want to delete the {{label}}",
	"Digite o título da análise para excluí-la": "Enter the title of the analysis to delete it",
	"Editar {{label}}": "Edit {{label}}",
	"Erro ao adicionar análise": "Error adding analysis",
	"Erro ao adicionar {{label}}": "Error adding {{label}}",
	"Erro ao adicionar item da Swot": "Error adding Swot item",
	"Erro ao alterar análise": "Error changing analysis",
	"Erro ao alterar {{label}}": "Error changing {{label}}",
	"Erro ao carregar {{label}}": "Error loading {{label}}",
	"Erro ao carregar análises": "Error loading analyzes",
	"Erro ao carregar dados do gráfico": "Error loading chart data",
	"Erro ao excluir análise": "Error deleting analysis",
	"Erro ao excluir {{label}}": "Error deleting {{label}}",
	"Erro ao mover {{label}}": "Error moving {{label}}",
	"Excluir {{label}}": "Delete {{label}}",
	"Exclusão de análise": "Exclusion of analysis",
	"Exclusão de {{label}}": "Exclusion of {{label}}",
	"Gráfico Análise": "Analysis Chart",
	"Item da Análise": "Analysis Item",
	"Item da Swot": "Swot Item",
	"Item Swot adicionado com sucesso": "Swot item successfully added",
	"Label 1 é requerida": "Label 1 is required",
	"Label 2 é requerida": "Label 2 is required",
	"Label 3 é requerida": "Label 3 is required",
	"Nenhuma análise selecionada": "No analysis selected",
	"Nenhum(a) {{label}} encontrado(a)": "None {{label}} found",
	"Nova análise": "New analysis",
	"Mover {{label}}": "Move {{label}}",
	"Painel de Análises": "Analysis Panel",
	"Permite adicionar elementos nível 1": "Allows you to add level 1 elements",
	"Selecione ao menos um quadrante da SWOT": "Select at least one quadrant of SWOT",
	"Título da análise não confere": "Analysis title does not match",
	"Utiliza Gráfico Radar": "Use Radar Chart",
	"Utiliza GUT": "Uses GUT",
	"Ver Item na SWOT": "See Item in SWOT",
	"Visualizar Gráfico": "View Chart",
	"{{label}} adicionado(a) com sucesso": "{{label}} successfully added",
	"{{label}} alterado(a) com sucesso": "{{label}} successfully changed",
	"{{label}} excluído(a) com sucesso": "{{label}} successfully deleted",
	"{{label}} movido(a) com sucesso": "{{label}} successfully moved"
};

export default ENAnalysisPanel;
